export default __webpack_public_path__ + "static/media/automatskavrata6.42b57937.png";